import { createClient } from '@supabase/supabase-js';
import { SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY } from './config.js';

export const supabase = createClient(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    // Magic-link flow (Q-D): the e-mailed link redirects back with tokens in
    // the URL — unlike the reception app, this client must consume them.
    detectSessionInUrl: true,
  },
});
